import O1HD from "../../../../engines/gameEngine";
import InputNode from "./InputNode";
import NormalGameManager from "../../manager/NormalGameManager";
import loveStoryRecordPrefab from "./loveStoryRecordPrefab";
import data_control from "../../../../engines/libs/data_control";
import WithdrawNode from "./WithdrawNode";
import {WithdrawChooseOption} from "./loveStoryConst";
import WithdrawResultPrefab from "./WithdrawResultPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loveStoryDetailPrefab extends cc.Component {


    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;
    @property({type:cc.Prefab,displayName:"记录预制体"})
    recordPrefab : cc.Prefab = null;
    @property({type:cc.Label,displayName:"Npc房间名称"})
    lbGirlName : cc.Label = null;
    @property({type:cc.Label,displayName:"男主所占百分比"})
    lbManPercent : cc.Label = null;
    @property({type:cc.Label,displayName:"女主所占百分比"})
    lbGirlPercent : cc.Label = null;
    @property({type:cc.Label,displayName:"男主自己金额"})
    lbManCoin:cc.Label = null;
    @property({type:cc.Label,displayName:"女主自己金额"})
    lbGirlCoin:cc.Label = null;
    @property({type:cc.Label,displayName:"全部钱文本"})
    lb_TotalCoin:cc.Label = null;
    @property({type:cc.Prefab,displayName:"输入预制体"})
    inputPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"爱心Node"})
    uiWaveNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"提现预制体"})
    withdrawPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"提现结果反馈预制体"})
    withdrawResultPrefab : cc.Prefab = null;


    private mPeopleName : string;

    onLoad(){
    }

    start(){

    }

    bindData( peopleName : string , width : number = null ){
        this.mPeopleName = peopleName;
        if ( width ) {
            this.node.width = width;
        }
        this.refreshData();
    }

    /**
     * 刷新数据
     */
    refreshData(){
        //清除所有数据
        this.itemContent.removeAllChildren();
        this.itemContent.destroyAllChildren();

        //加载所有数据
        let peopleData = NormalGameManager._instance.loveStroyManager.getOnePeople(this.mPeopleName);
        let girlMoney : number = peopleData.otherCoin;
        let manMoney : number = peopleData.meCoin;
        for ( let i = peopleData.storyRecord.length -1 ; i >= 0 ; i -- ) {
            let storyItem = peopleData.storyRecord[i];
            // if ( storyItem.peopleId == "自己" ) {
            //     manMoney += storyItem.coin;
            // }else{
            //     girlMoney += storyItem.coin;
            // }
            let recordPrefabNode = cc.instantiate( this.recordPrefab );
            this.itemContent.addChild( recordPrefabNode );
            recordPrefabNode.getComponent( loveStoryRecordPrefab ).bindData( this.mPeopleName , storyItem ).then();
        }

        this.lbGirlName.string = `${this.mPeopleName}`;

        this.lbManCoin.string = `${data_control.getNumberFormat(manMoney)}`;
        this.lbGirlCoin.string = `${data_control.getNumberFormat(girlMoney)}`;
        this.lb_TotalCoin.string = `${data_control.getNumberFormat( peopleData.totalCoin )}`

        let girlPercent = girlMoney / ( girlMoney + manMoney ) ;
        this.lbGirlPercent.string = `${data_control.getNumberFormat(girlPercent * 100)}%`;
        this.lbManPercent.string = `${data_control.getNumberFormat(100-(girlPercent * 100))}%`;
        // 控制爱心的位置
        this.uiWaveNode.y = -460 + (420 * girlPercent);
    }

    /**
     * 返回
     */
    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    /**
     * 存款
     */
    onBtnDeposit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let inputNode = cc.instantiate( this.inputPrefab );
        this.node.addChild( inputNode );
        inputNode.getComponent( InputNode ).bindData("请输入存款金额" , this.depositCallBack.bind(this) );
    }
    //存款回调
    depositCallBack( money : number ){
        O1HD.getServices().userSrv.setCoins( -money , true );
        NormalGameManager._instance.loveStroyManager.addOneRecord(this.mPeopleName,"自己",`存入${data_control.getNumberFormat(money)}`,money,2,"" );
        this.refreshData();
    }

    /**
     * 取款
     */
    onBtnWithdraw(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let withdrawNode = cc.instantiate( this.withdrawPrefab );
        withdrawNode.getComponent( WithdrawNode ).bindData( NormalGameManager._instance.loveStroyManager.getOnePeople( this.mPeopleName ) , this.withdrawCallBack.bind( this ));
        this.node.addChild( withdrawNode );
    }
    //提现 回调
    withdrawCallBack( chooseOption : WithdrawChooseOption ){
        // 添加取款记录
        let people = NormalGameManager._instance.loveStroyManager.getOnePeople( chooseOption.peopleId );
        let addCoin = - Math.floor( people.totalCoin * chooseOption.withdrawCoinsPercent / 100 );
        NormalGameManager._instance.loveStroyManager.addOneRecord( chooseOption.peopleId
        , "自己", chooseOption.chooseDesc , addCoin , chooseOption.withdrawSuccessFlag ? 2 : -1 , chooseOption.withdrawReplayContent , 2 );
        //刷新记录
        this.refreshData();
        //打开结果页面
        let withdrawResultPrefab = cc.instantiate( this.withdrawResultPrefab );
        this.node.addChild( withdrawResultPrefab );
        withdrawResultPrefab.getComponent( WithdrawResultPrefab ).bindData( chooseOption , addCoin ).then();
    }

}
